module.exports = __webpack_public_path__ + "static/media/nexus-of-fate.6fe04a27.jpg";